// Handlers for getting organization affiliation user
export interface U2104UseGetOrganizatonAffiliationHandlersParams<T = any> {
  doGetFn: (id: string, userId: string) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for organization affiliation handlers
export interface U2104UseGetOrganizatonAffiliationHandlersReturn {
  getOrganizationUser: (id: string, userId: string) => void;
}

// Handlers for getting organization affiliation user
export function useU2104UseGetOrganizatonAffiliaitionHandlers<T extends { id: string } = any>({
  doGetFn,
  onSuccess,
  onError,
}: U2104UseGetOrganizatonAffiliationHandlersParams<T>): U2104UseGetOrganizatonAffiliationHandlersReturn {
  const getOrganizationUser = async (id: string, userId: string) => {
    try {
      const response = await doGetFn(id, userId);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getOrganizationUser };
}
